import { LocalStorageService, get } from '../services';

import { LocalStorageKeys, NotificationType } from '../enums';
import type { TUserData } from '../types';
import { activeRequestsAtom } from '../../atoms';
import { useAddNotification } from './useNotificationHandlers';
import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from './useTranslation';

export function useGetUserProfile() {
  const setActiveRequests = useSetRecoilState(activeRequestsAtom);
  const pushNotification = useAddNotification();
  const { t } = useTranslation();

  const getUserData = useCallback(async () => {
    if (!LocalStorageService.getItem(LocalStorageKeys.AccessToken)) return;
    setActiveRequests(prev => prev + 1);
    const { data, error } = await get('USER_PROFILE');
    setActiveRequests(prev => prev - 1);
    if (!!error) {
      console.log(error);
      pushNotification({
        type: NotificationType.Error,
        title: t('Web.Title_load_error'),
        text: t('Web.Error_user_profile_load_failed'),
      });
      return null;
    } else {
      return data as TUserData;
    }
  }, [setActiveRequests, pushNotification, t]);

  return { getUserData };
}
